import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import {
  Bell,
  Calendar,
  ChevronRight,
  LucideAngularModule,
  Settings,
  Sparkles,
  Users,
  X,
} from 'lucide-angular';
import { OnboardingStep } from '../../../models/tour.model';

@Component({
  selector: 'app-tour',
  imports: [LucideAngularModule],
  templateUrl: './tour.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Tour {
  readonly onComplete = output<void>();

  readonly currentStep = signal(0);

  readonly steps: OnboardingStep[] = [
    {
      title: 'Seja bem-vindo ao EVNT CRM!',
      description:
        'Este é o seu novo centro de comando. Aqui você visualiza o ROI em tempo real e o faturamento de todas as suas verticais de eventos e grupos.',
      icon: Sparkles,
      target: 'Dashboard',
    },
    {
      title: 'Gestão de Contas e Segmentos',
      description:
        "No menu 'Carteira', você organiza seus leads por classe (A, B, C) e segmento, garantindo que nenhum hotel ou restaurante fique sem atenção.",
      icon: Users,
      target: 'Carteira',
    },
    {
      title: 'Agenda e Sincronismo Operacional',
      description:
        'Sincronize o que foi vendido com o que será executado. Agende visitas técnicas e reuniões de alinhamento diretamente aqui.',
      icon: Calendar,
      target: 'Agenda',
    },
    {
      title: 'Revenue Engine & Metas',
      description:
        "Em 'Configurações', você define metas para o time e gerencia o inventário de espaços. O CRM que trabalha para o seu faturamento.",
      icon: Settings,
      target: 'Setup',
    },
    {
      title: 'Central de Alertas',
      description:
        'Receba notificações em tempo real sempre que o operacional do hotel alterar algo em uma proposta sua. Transparência total!',
      icon: Bell,
      target: 'Alertas',
    },
  ];

  readonly icons = {
    x: X,
    chevronRight: ChevronRight,
  };

  get step(): OnboardingStep {
    return this.steps[this.currentStep()];
  }

  handleNext(): void {
    if (this.currentStep() < this.steps.length - 1) {
      this.currentStep.set(this.currentStep() + 1);
    } else {
      this.handleComplete();
    }
  }

  handleComplete(): void {
    this.onComplete.emit();
  }

  isLastStep(): boolean {
    return this.currentStep() === this.steps.length - 1;
  }
}
